import {
  Component,
  ViewEncapsulation,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { GlobalSubheaderDataService } from "../global-subheader-data.service";
import {
  VAIconRegistryService,
  exclamationTriangle,
  infoCircle,
  star,
} from "@va/core-library/icons";

@Component({
  selector: "app-subheader-company-notes",
  templateUrl: "./subheader-company-notes.component.html",
  styleUrls: ["./subheader-company-notes.component.scss"],
  host: { class: "subheader-notes-section" },
  encapsulation: ViewEncapsulation.None,
})
export class SubheaderCompanyNotesComponent implements OnChanges {
  hasCriticalNote: boolean;
  hasInformativeNote: boolean;
  notes;
  type: string;
  @Input() ticker: string;
  currentNotes;
  constructor(
    private dataService: GlobalSubheaderDataService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([infoCircle, exclamationTriangle, star]);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.ticker.currentValue &&
      changes.ticker.currentValue !== changes.ticker.previousValue
    ) {
      this.notes = {
        critical: [],
        informative: [],
      };
      this.dataService.getCompanyLevelNotes(this.ticker).subscribe(
        (response) => {
          if (response.Informative)
            this.notes.informative = response.Informative;
          if (response.Critical) this.notes.critical = response.Critical;

          this.hasCriticalNote = this.notes.critical.length > 0;
          this.hasInformativeNote = this.notes.informative.length > 0;
        },
        (err) => {
          throw err;
        },
      );
    }
  }

  popoverType(currentType) {
    this.currentNotes = this.notes[currentType];
  }
}
